module.exports = __webpack_public_path__ + "static/Finance1-4cd9194efc611afde603b43f0dca8a9b.png";